var e={exports:{}};export{e as __module};
//# sourceMappingURL=index2.js.map
